import { useTranslation } from 'react-i18next';
export function InterviewWelcomeMessage() {
  const { t } = useTranslation('audiences');

  return (
    <div className="flex w-full flex-col gap-4 px-4 pt-6">
      <span className="text-sm font-medium leading-5 tracking-tight text-foreground">
        {t('audienceInterview.interviewWelcomeMessage.moderator')}
      </span>
      <div className="max-w-[450px] rounded-bl-2xl rounded-br-2xl rounded-tr-2xl bg-muted px-5 py-4">
        <p className="text-base leading-6 tracking-tight text-foreground">
          {t('audienceInterview.interviewWelcomeMessage.welcomeToTheInterviewSession')}
        </p>
      </div>
    </div>
  );
}
